const ITEMS = [
  "Online UPS",
  "Off-Line UPS",
  "Industrial UPS",
  "Rack-Mount UPS",
  "Servo Stabilizers",
  "Isolation Transformers",
  "SMF / VRLA / NICD",
  "Lithium Battery",
  "On-Grid Solar",
  "Off-Grid Solar",
  "ACDB Panels",
  "Cooling Rack",
  "Modular Rack Cooling",
  "VRC Self-Contained",
  "Diesel & NG Gensets",
  "CAMC / NAMC",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-strip"
      className="bg-damita-blue text-white border-y border-damita-blue overflow-hidden"
    >
      <div className="marquee-track flex items-center gap-12 py-5">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-display font-bold text-xl md:text-2xl tracking-tight whitespace-nowrap">{t}</span>
            <span className="w-2 h-2 bg-damita-yellow rounded-full shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
